import { css } from '@/styled-system/css';

export const adornedInputIconStyles = css.raw({
  width: 'AdornedInput.Icon.width',
  height: 'AdornedInput.Icon.height',
});
